import * as React from 'react';
import { Attention } from '../icons';
import { COLORS } from '../styles';
import { ErrorMessage, InputFieldStyling, InputWrapper, RequiredStar, WarningMessage } from './styling';

type TextFieldProps = {
  id: string;
  disabled?: boolean;
  locked?: boolean;
  onChange?: (text: string) => void;
  hasError?: boolean;
  value?: string;
  validationMessage?: string;
  validationIsCritical?: boolean;
  type?: string;
  autoComplete?: string;
  placeholder?: string;
  required?: boolean;
  correct?: boolean;
  pattern?: string;
  maxLength?: number;
};

const TextField = ({
  id,
  disabled,
  locked,
  onChange,
  hasError,
  value,
  validationMessage,
  validationIsCritical,
  type,
  autoComplete,
  placeholder,
  required,
  correct,
  pattern,
  maxLength,
}: TextFieldProps) => {
  const inputRef = React.useRef<any>(null);
  const [tabbedHere, setTabbedHere] = React.useState<boolean>(false);
  return (
    <>
      {required && <RequiredStar>*</RequiredStar>}
      <InputWrapper
        tabIndex={locked || disabled ? -1 : 0}
        onFocus={(e: any) => {
          if (e?.target?.id !== id && !(locked || disabled)) {
            setTabbedHere(true);
            inputRef.current.focus();
          }
        }}
        locked={locked}
        disabled={disabled}
        onClick={(e: any) => {
          if (disabled || locked) {
            e.preventDefault();
          }
        }}>
        <InputFieldStyling
          id={id}
          ref={inputRef}
          type={type || 'text'}
          value={value}
          className={hasError ? 'error' : ''}
          tabIndex={-1}
          autoComplete={autoComplete}
          placeholder={placeholder}
          disabled={disabled}
          locked={locked}
          onChange={(e: any) => onChange && onChange(e?.target?.value || '')}
          activeValidationMessage={validationMessage !== '' && validationMessage !== undefined}
          activeErrorMessage={validationMessage !== '' && validationMessage !== undefined && validationIsCritical}
          required={required}
          correctInput={correct}
          tabbedHere={tabbedHere}
          pattern={pattern}
          maxLength={maxLength}
          onBlur={() => setTabbedHere(false)}
        />
      </InputWrapper>
      {validationMessage && !validationIsCritical && (
        <WarningMessage>
          <Attention size="20px" color={COLORS.warning_400} />
          <span>{validationMessage}</span>
        </WarningMessage>
      )}
      {validationMessage && validationIsCritical && (
        <ErrorMessage>
          <Attention size="20px" color={COLORS.critical_400} />
          <span>{validationMessage}</span>
        </ErrorMessage>
      )}
    </>
  );
};

export default TextField;
